import Vue from 'vue'
import Vuex from 'vuex'
import persistedstate from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    now_hands: [],
    hands_history: [],
    count: 0,
    no_action: true,
    showModalDialog: false,
    modal_msg: '',
    callback_func: null,
    memo_list: [],
    memo_detail_sheet_no: null,
    header_memo: '',
  },
  mutations: {
    set_showModalDialog(state, showModalDialog) {
      state.showModalDialog = showModalDialog
    },
    set_modal_msg(state, modal_msg) {
      state.modal_msg = modal_msg
    },
    set_callback_func(state, callback_func) {
      state.callback_func = callback_func
    },
    // 最新のハンドを追加
    add_hands(state) {
      console.log('start add_hands')
      console.log('state.count: ' + state.count)
      state.hands_history[state.count] = JSON.parse(JSON.stringify(state.hands_history[state.count - 1]))
      for (let i = 0; i < 10; i++) {
        // ハンド更新はシットアウトしてない場合だけ
        if (!state.hands_history[state.count][i]['is_sitout']) {
          state.hands_history[state.count][i]['hands'] += 1
          state.hands_history[state.count][i]['status'] = ''
        }
      }
      state.now_hands = JSON.parse(JSON.stringify(state.hands_history[state.count]))
    },
    // 前のハンドを継続
    add_hands_in_old(state) {
      console.log('start add_hands_in_old')
      console.log('state.count: ' + state.count)
      // データは引き継ぐ
      for (let i = 0; i < 10; i++) {
        if (state.hands_history[state.count][i]['is_sitout'] == 1) continue
        state.hands_history[state.count][i]['hands'] = state.hands_history[state.count - 1][i]['hands'] + 1
        state.hands_history[state.count][i]['vpip'] = state.hands_history[state.count - 1][i]['vpip']
        state.hands_history[state.count][i]['pfr'] = state.hands_history[state.count - 1][i]['pfr']
      }
      state.now_hands = JSON.parse(JSON.stringify(state.hands_history[state.count]))
    },
    // ハンド履歴をクリア
    initialize_hand_onesit(state, sheet_no) {
      // ハンド履歴マスタでループ
      for (let i = 0; i < state.count + 1; i++) {
        for (let j = 0; j < 10; j++) {
          if (sheet_no == state.hands_history[i][j].sheet_no) {
            state.hands_history[i][j] = {
              sheet_no: sheet_no,
              status: '',
              vpip: 0,
              pfr: 0,
              hands: 0,
              is_sitout: 1,
            }
          }
        }
      }
      state.now_hands = JSON.parse(JSON.stringify(state.hands_history[state.count]))
    },
    // １件のメモをクリア
    clear_one_memo(state, sheet_no) {
      if (sheet_no == 0) return
      console.log('sheet_no: ' + sheet_no)
      for (let i = 0; i < state.memo_list.length; i++) {
        if (sheet_no - 1 == state.memo_list[i].sheet_no) {
          state.memo_list[i] = {
            contents: '',
            date: '',
            sheet_no: i,
          }
        }
      }
      state.now_hands = JSON.parse(JSON.stringify(state.hands_history[state.count]))
    },
    initialize_hands_history(state) {
      state.count = 0
      state.hands_history = []
      let hands = []
      for (let i = 0; i < 10; i++) {
        hands[i] = {
          sheet_no: i + 1,
          status: '',
          vpip: 0,
          pfr: 0,
          hands: 1,
          is_sitout: 0,
        }
        if (i == 9) {
          hands[i].is_sitout = 1
          hands[i].hands = 0
        }
      }
      state.hands_history.push(hands)
      state.now_hands = JSON.parse(JSON.stringify(hands))
    },
    initialize_memo_list(state) {
      state.header_memo = ''
      state.memo_list = []
      for (let i = 0; i < 10; i++) {
        state.memo_list.push({
          contents: '',
          date: '',
          sheet_no: i,
        })
      }
    },
    increment_count(state) {
      state.count += 1
    },
    decrement_count(state) {
      console.log('start decrement_count')
      state.count -= 1
      state.now_hands = JSON.parse(JSON.stringify(state.hands_history[state.count]))
    },
    update_hands(state, hands) {
      console.log('state.count: ' + state.count)
      // listの中の変更はcomputedで検知できないので丸ごと更新する
      state.hands_history[state.count] = JSON.parse(JSON.stringify(hands))
      state.now_hands = JSON.parse(JSON.stringify(hands))
    },
    update_memo_list(state, memo_list) {
      state.memo_list = JSON.parse(JSON.stringify(memo_list))
    },
    increment_vpip(state, sheet_no) {
      console.log('start increment_vpip')
      for (let i = 0; i < 10; i++) {
        if (sheet_no == state.hands_history[state.count][i]['sheet_no']) {
          state.hands_history[state.count][i]['vpip'] += 1
        }
      }
      state.now_hands = JSON.parse(JSON.stringify(state.hands_history[state.count]))
    },
    decrement_vpip(state, sheet_no) {
      console.log('start decrement_vpip')
      for (let i = 0; i < 10; i++) {
        if (sheet_no == state.hands_history[state.count][i]['sheet_no']) {
          state.hands_history[state.count][i]['vpip'] -= 1
        }
      }
      state.now_hands = JSON.parse(JSON.stringify(state.hands_history[state.count]))
    },
    increment_pfr(state, sheet_no) {
      console.log('start increment_pfr')
      for (let i = 0; i < 10; i++) {
        if (sheet_no == state.hands_history[state.count][i]['sheet_no']) {
          state.hands_history[state.count][i]['pfr'] += 1
        }
      }
      state.now_hands = JSON.parse(JSON.stringify(state.hands_history[state.count]))
    },
    decrement_pfr(state, sheet_no) {
      console.log('start decrement_pfr')
      for (let i = 0; i < 10; i++) {
        if (sheet_no == state.hands_history[state.count][i]['sheet_no']) {
          state.hands_history[state.count][i]['pfr'] -= 1
        }
      }
      state.now_hands = JSON.parse(JSON.stringify(state.hands_history[state.count]))
    },
    update_sitout(state, sheet_no) {
      console.log('start update_sitout')
      // 浅いコピー
      let hands = state.hands_history[state.count]
      for (let i = 0; i < 10; i++) {
        if (hands[i]['sheet_no'] == sheet_no) {
          // シットアウト状態を更新
          hands[i]['is_sitout'] = hands[i]['is_sitout'] == 0 ? 1 : 0
          // ハンド数を更新
          if (hands[i]['is_sitout']) {
            hands[i]['hands'] -= 1
          } else {
            hands[i]['hands'] += 1
          }
        }
      }
      // listの中の変更はcomputedで検知できないので丸ごと更新する
      state.hands_history = JSON.parse(JSON.stringify(state.hands_history))
      state.now_hands = JSON.parse(JSON.stringify(state.hands_history[state.count]))
    },
    change_status_hands(state, sheet_no) {
      for (let i = 0; i < 10; i++) {
        if (sheet_no == state.hands_history[state.count][i].sheet_no) {
          if (state.hands_history[state.count][i]['status'] == 'call') {
            state.hands_history[state.count][i]['status'] = 'raise'
          } else if (state.hands_history[state.count][i]['status'] == 'raise') {
            state.hands_history[state.count][i]['status'] = ''
          } else {
            state.hands_history[state.count][i]['status'] = 'call'
          }
        }
      }
      // listの中の変更はcomputedで検知できないので丸ごと更新する
      state.hands_history = JSON.parse(JSON.stringify(state.hands_history))
      state.now_hands = JSON.parse(JSON.stringify(state.hands_history[state.count]))
    },
    pop_hands(state) {
      state.hands_history.pop()
      state.now_hands = JSON.parse(JSON.stringify(state.hands_history[state.count - 1]))
    },
    set_no_action(state, no_action) {
      state.no_action = no_action
    },
    set_memo_detail_sheet_no(state, memo_detail_sheet_no) {
      state.memo_detail_sheet_no = memo_detail_sheet_no
    },
    set_header_memo(state, header_memo) {
      state.header_memo = header_memo
    },
    update_memo(state, { sheet_no, contents }) {
      console.log('sheet_no: ' + sheet_no)
      console.log('contents: ' + contents)
      for (let i = 0; i < 10; i++) {
        if (sheet_no == state.memo_list[i]['sheet_no']) {
          state.memo_list[i]['contents'] = contents
        }
      }
      console.log(state.memo_list)
    },
  },
  actions: {
    clear_one(context, sheet_no) {
      context.commit('initialize_hand_onesit', sheet_no)
    },
    clear_all(context) {
      console.log('start clear_all')
      context.commit('initialize_hands_history')
      context.commit('initialize_memo_list')
    },
  },
  plugins: [persistedstate()],
})
